/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Em_DashInputs */

const en_common_em_dash = /** @type {(inputs: Common_Em_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`—`)
};

const pt_br2_common_em_dash = /** @type {(inputs: Common_Em_DashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`—`)
};

/**
* | output |
* | --- |
* | "—" |
*
* @param {Common_Em_DashInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const common_em_dash = /** @type {((inputs?: Common_Em_DashInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Em_DashInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_em_dash(inputs)
	return pt_br2_common_em_dash(inputs)
});